import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { IF } from 'lidya-common-components';
// import classNames from 'classnames';
import { COMPONENTS, COUNTRY_LANGUAGE_LIST } from '../../common/webSiteLanguages';
import { ContextLink } from '../../common/contextLink';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { getLinkByComponentName } from '../../../hooks/useNavigationLinks';
import { PhoneFieldComponent } from './formFields/phone.field';
import { NameField } from './formFields/name.field';
import { LastNameField } from './formFields/last.name.field';
import { EmailFieldComponent } from './formFields/email.field';
import { RetypeEmailField } from './formFields/retype.email.field';
import { CheckBoxField } from './formFields/agree.checkbox';

// const windowGlobal = typeof window !== 'undefined' && window;

const LinkToTermsOrPrivacy = () => {
  const { country, language } = useGlobalData();
  const countryDefs = COUNTRY_LANGUAGE_LIST[country];
  const { t } = useTranslation();
  const { hasWebApp, privacy_policy } = countryDefs;
  const label = privacy_policy
    ? t('web.footer.privacy.policy')
    : t('web.footer.terms.conditions');
  const component = privacy_policy
    ? COMPONENTS.PRIVACYPOLICY
    : COMPONENTS.TERMSCONDITIONS;

  const link = getLinkByComponentName({
    componentName: component,
    country,
  });
  const slug = link[`slug_${language}`];
  const { new_tab: newTab } = link;

  if (hasWebApp || privacy_policy) {
    return (
      <>
        {t('web.sign.up.form.read.terms')}
        <ContextLink
          id={`HomeLink${slug}`}
          to={slug}
          className="m-navigation__linkLogo"
          aria-label={slug}
          target={newTab ? '_blank' : undefined}
        >
          {` ${label}`}
        </ContextLink>
      </>
    );
  }
  return label;
};

export const FormFields = function ({ noRetypeEmail }) {
  return (
    <div className="m-fieldGroup__fields">
      <NameField />
      <LastNameField />
      <EmailFieldComponent />
      {!noRetypeEmail && (
        <RetypeEmailField />
      )}
      <IF
        condition={!noRetypeEmail}
        Else={PhoneFieldComponent}
      >
        <div className="a-fieldGroup__emailField">
          <PhoneFieldComponent />
        </div>

      </IF>

      <div className="a-fieldGroup__checkboxField">
        <CheckBoxField />
      </div>
      <span className="a-fieldGroup__agreeSide">
        <LinkToTermsOrPrivacy />
      </span>
    </div>
  );
};

FormFields.propTypes = {
  noRetypeEmail: PropTypes.bool,
};

FormFields.defaultProps = {
  noRetypeEmail: undefined,

};

export default FormFields;
